export default __webpack_public_path__ + "static/media/player-captain.d32b2808.svg";